import request from '@/utils/request'

// 查询【产品信息】列表

export function listBottom(params) {
  return request({
    url: '/bottom/list',
    method: 'get',
    params: params
  })
}
export function addBottom(data) {
  return request({
    url: '/bottom/add',
    method: 'post',
    data: data
  })
}
export function updateBottom(data) {
  return request({
    url: '/bottom/updateBottom',
    method: 'post',
    data: data
  })
}
export function selectById(params) {
  return request({
    url: '/bottom/selectById',
    method: 'get',
    params: params
  })
}
export function checkBottom(data) {
  return request({
    url: '/bottom/checkBottom',
    method: 'post',
    data: data
  })
}


